import { mrhrootMenuList } from "./mrh-root-menu-list";
export function mrh_rootarraymenu(root:any,rootMenus:any) {
    $('.dropdown.menu-large a[href="'+root.link+'"]').parent().remove();
    rootMenus.push(mrhrootMenuList(root));
}